import { Component, Injector, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { ComponentService } from '../../../shared/abstract/component.service';
import { GeneralQueryModel } from '../../../shared/model/general-query-model';
import { RequestService } from '../../../shared/services/request.service';

interface SearchParams {
  searchTerm: string | boolean;
  all: boolean;
  columnName?: string;
}

@Component({
  selector: 'app-action-logs',
  templateUrl: './action-logs.component.html',
  styleUrl: './action-logs.component.css',
})
export class ActionLogsComponent
  extends ComponentService<any>
  implements OnInit
{
  constructor(
    injector: Injector,
    private _request: RequestService,
  ) {
    super(injector);
    this.searchSubject.pipe(debounceTime(600)).subscribe((searchParam) => {
      this.filter(searchParam.searchTerm, searchParam.columnName);
    });
  }

  dataSource = new MatTableDataSource<any>();
  userSearchLength : any;
  properties: any[] = [];
  searchValues: any[] = [];
  pageIndex = 0;
  pageSize = 5;
  currentPage = 0;
  totalPages = 0;
  maxVisibleButtons = 5;
  Math = Math;
  searchInput: string = '';
  private searchSubject: Subject<SearchParams> = new Subject();
  displayedColumns: string[] = [
    'platform',
    'source',
    'operations',
    'foreignId',
    'userId',
    'duration',
    'createdDate',
    'device',
    'osVersion'
  ];

  inputValues = {
    platform: null,
    source: null,
    operations: null,
    foreignId: null,
    userId: null,
    duration: null,
    createdDate: null,
    device: null,
    osVersion: null,
  };

  propertiesForColumn: any[] = [];
  searchValuesForColumn: any[] = [];

  ngOnInit(): void {
    this.getPaginatedQuery();
  }

  getPaginatedQuery() {
    let model: GeneralQueryModel = new GeneralQueryModel();

    model.propertyNames = this.propertiesForColumn;
    model.searchValues = this.searchValuesForColumn;
    model.and = true;
    model.orderColumn = 'createdDate';
    model.order = 'desc';
    model.index = this.pageIndex;
    model.size = this.pageSize;

    this._request
      .getOperationLogs(model)
      .then((_) => {
        if (_.data.items) {
          this.dataSource.data = _.data.items;
          this.userSearchLength = _.data.count;
        }
      })
      .catch((err) => {
        this.MessageBox(err.message ?? '', 'warn', 'center');
      })
      .finally(() => {
        this.updateTotalPages();
      });
  }

  refreshTableAfterAction() {
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
    this.updateTotalPages();
  }

  onInputChange(
    event: Event | any,
    all: boolean = false,
    columnName?: string
  ): void {
    let searchTerm: string | boolean = '';

    if (event || event.target) {
      const inputElement = event.target
        ? (event.target as HTMLInputElement).value
        : event.toString();
      searchTerm = inputElement;
    } else {
      searchTerm = event;
    }
    this.searchSubject.next({ searchTerm, all, columnName });
  }

  filter(searchTerm: string | boolean, columnName?: string): void {
    if (columnName) {
      const propertyIndex = this.propertiesForColumn.indexOf(columnName);

      if (propertyIndex !== -1) {
        if (
          searchTerm === '' ||
          searchTerm === null ||
          searchTerm === undefined
        ) {
          this.propertiesForColumn.splice(propertyIndex, 1);
          this.searchValuesForColumn.splice(propertyIndex, 1);
        } else {
          this.searchValuesForColumn[propertyIndex] = searchTerm;
        }
      } else {
        this.propertiesForColumn.push(columnName);
        const newPropertyIndex = this.propertiesForColumn.indexOf(columnName);
        this.searchValuesForColumn[newPropertyIndex] = searchTerm;
      }
    }

    this.currentPage = 0;
    this.pageIndex = 0;

    this.getPaginatedQuery();
  }
  get visiblePageNumbers(): number[] {
    const start = Math.max(
      0,
      Math.min(
        this.currentPage - Math.floor(this.maxVisibleButtons / 2),
        this.totalPages - this.maxVisibleButtons
      )
    );
    return Array.from(
      { length: Math.min(this.maxVisibleButtons, this.totalPages) },
      (_, i) => start + i + 1
    );
  }

  onPageChange(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
    }
    this.pageIndex = pageIndex;
    this.getPaginatedQuery();
  }

  updatePageSize(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.pageSize = parseInt(selectElement.value, 10);
    this.refreshTableAfterAction();
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  updateTotalPages() {
    this.totalPages = Math.ceil(this.userSearchLength / this.pageSize);
  }
}
